import { createRouter, createWebHistory } from "vue-router";
/**
 * meta:
 * loginDirect，登入頁面的登入後跳轉頁
 * needLogin: 是否需要登入
 * loginPage: 若需要登入，登入頁面的name
 * onlyDev: 正式區不顯示這個頁面
 */
const routes = [
    //Staff
    { path: "/Staff/Login", name: "Staff.Login", component: () => import("@/views/staff/StaffLogin.vue"), meta: { loginDirect: "Staff.Account" } },
    {
        path: "/Staff",
        name: "Staff",
        component: () => import("@/views/staff/Layout.vue"),
        children: [
            { path: "", name: "Staff.Home", redirect: { name: "Staff.Account" } },
            { path: "Account", name: "Staff.Account", component: () => import("@/views/staff/Account.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
            { path: "AppReview", name: "Staff.AppReview", component: () => import("@/views/staff/AppReview.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
            { path: "Subscriber", name: "Staff.Subscriber", component: () => import("@/views/staff/Subscriber.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
            { path: "Transaction", name: "Staff.Transaction", component: () => import("@/views/staff/Transaction.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
            { path: "Spine", name: "Staff.Spine", component: () => import("@/views/staff/SpineFile.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
            { path: "OBS", name: "Staff.OBS", component: () => import("@/views/staff/OBSWebsocket.vue"), meta: { needLogin: true, loginPage: "Staff.Login" } },
        ],
        meta: { needLogin: true, loginPage: "Staff.Login" },
    },

    //後台
    { path: "/Login", name: "Backend.Login", component: () => import("@/views/dashboard/BackendLogin.vue"), meta: { loginDirect: "Backend.SceneGroup" } },
    {
        path: "/Dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/Layout.vue"),
        children: [
            { path: "", name: "Backend.Dashboard", component: () => import("@/views/dashboard/BackendDashboard1.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "Avatar", name: "Backend.Avatar", component: () => import("@/views/dashboard/BackendAvatar.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "Links", name: "Backend.Links", component: () => import("@/views/dashboard/BackendLinks.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "Scene", name: "Backend.SceneGroup", component: () => import("@/views/dashboard/BackendSceneGroup.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "Scene/:ID", name: "Backend.Scene", component: () => import("@/views/dashboard/BackendScene/BackendScene.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "DropHistory", name: "Backend.DropHistory", component: () => import("@/views/dashboard/BackendDropHistory.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "PaymentSetting", name: "Backend.PaymentSetting", component: () => import("@/views/dashboard/BackendPaymentSetting.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
            { path: "Billing", name: "Backend.Billing", component: () => import("@/views/dashboard/BackendBilling.vue"), meta: { needLogin: true, loginPage: "Backend.Login" } },
        ],
        meta: { needLogin: true, loginPage: "Backend.Login" },
    },
    { path: "/auth/google/callback", name: "GoogleAuthCallback", component: () => import("@/views/auth/GoogleAuthCallback.vue") },
    { path: "/auth/twitch/callback", name: "TwitchAuthCallback", component: () => import("@/views/auth/TwitchAuthCallback.vue") },
    { path: "/auth/discord/callback", name: "DiscordAuthCallback", component: () => import("@/views/auth/DiscordAuthCallback.vue") },
    { path: "/payback/paypal", name: "PaypalPayback", component: () => import("@/views/payment/PaypalReturn.vue") },

    //小工具
    { path: "/Widget/Star/:Token", name: "Widget.Star", component: () => import("@/views/widget/StarWidget.vue"), props: true },
    { path: "/Widget/Avatar/:Token", name: "Widget.Avatar", component: () => import("@/views/widget/AvatarWidget.vue"), props: true },
    { path: "/Widget/Scene/:Token/:ID/:ShowBackground/:TargetID?", name: "Widget.Scene", component: () => import("@/views/widget/SceneWidget.vue"), props: true },

    //前台
    { path: "/:UrlName/StarPanel/:Percent?", name: "FrontEnd.Star", component: () => import("@/views/room/StarPanel.vue") },
    { path: "/:UrlName/AvatarPanel", name: "FrontEnd.Avatar", component: () => import("@/views/room/AvatarPanelSpine2.vue") },
    { path: "/:UrlName/Room/:ID", name: "FrontEnd.Scene", component: () => import("@/views/room/Scene/ScenePanel.vue") },
    { path: "/:UrlName/OwnerRoom/:ID", name: "FrontEnd.Scene.Owner", component: () => import("@/views/room/Scene/OwnerScenePanel.vue") },
    { path: "/AccountTransactions", name: "FrontEnd.AccountTransactions", component: () => import("@/views/room/AccountTransactions.vue") },

    //其他
    { path: "/", name: "Home", component: () => import("@/views/HomePage.vue"), meta: { onlyDev: true } },
    { path: "/Landing/:tab?", name: "Landing", component: () => import("@/views/LandingPage.vue") },
    { path: "/Landingv2", name: "Landingv2", component: () => import("@/views/LandingPage_PCV2.vue") },
    { path: "/PrivacyPolicy", name: "PrivacyPolicy", component: () => import("@/views/PrivacyPolicy.vue") },
    //{ path: "PreOrder", name: "PreOrder", },

    //測試
    { path: "/changeColor", name: "changeColor", component: () => import("@/views/test/ChangeColor.vue") },
    { path: "/:UrlName/AvatarPanelKonva", name: "FrontEnd.AvatarKonva", component: () => import("@/views/room/AvatarPanelKonva.vue") },
    { path: "/UploadAvatar", name: "UploadAvatar", component: () => import("@/views/test/UploadAvatar.vue") },

    { path: "/Test/Spine_canvas", name: "Spine", component: () => import("@/views/test/spine/Spine-canvas.vue") },
    { path: "/Test/Spine_phaser", name: "Spine_phaser", component: () => import("@/views/test/spine/Spine-phaser.vue") },
    { path: "/Test/Spine_webgl", name: "Spine_webgl", component: () => import("@/views/test/spine/Spine-webgl.vue") },
    { path: "/Test/CustomizeScene", name: "CustomizeScene", component: () => import("@/views/test/CustomizeScene.vue") },
    { path: "/Test/MyPay", name: "MyPay", component: () => import("@/views/test/MyPayTest.vue") },
    { path: "/Test/CardCheck", name: "CardCheck", component: () => import("@/views/test/CardPrototype.vue") },
    { path: "/Test/Gashapon", name: "Gashpon", component: () => import("@/views/test/GashaponPrototype.vue") },
    { path: "/Test/Scratchcard", name: "Scratchcard", component: () => import("@/views/test/NewScratchCardTest.vue") },
];

const isProd = process.env.VUE_APP_ENV === "production";
const filteredRoutes = isProd ? routes.filter((r) => !r.meta?.onlyDev) : routes;

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: filteredRoutes,
});

export default router;
